// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1yHp5","title":"InfoRow_title__1kzW7"};